const palette = {
  primary: [
    '#3eaeff', // Blue
    '#fc5858', // Red
    '#26ce93', // Green
    '#f5c623', // Yellow
  ],
  text: '#2b2b2b',
  border: '#d1d1d1',
  label: '#acacac',
};

export default palette;
